module.exports = __webpack_public_path__ + "img/onboarding-intro.dbd0cd07.svg";